import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import Raw from '../../raw';
import moment from 'moment';
import DatePicker from '../../date-picker';
import PromoMessage from '../../promo-message';

class Component extends BaseComponent {
    render({ route }) {
        if (route != 'everyone') {
            return this.renderForYou();
        }

        return this.renderForEveryone();
    }

    renderForYou = () => {
        if (this.props.logged_in && this.props.hexagram && this.props.hexagram.you) {
            return (
                <daily-hexagram-non-mobile>
                    {this.renderHexagram(this.props.hexagram.you)}
                </daily-hexagram-non-mobile>
            );
        }

        return (
            <daily-hexagram-non-mobile>
                <div class='daily-hexagram'>
                    <img
                      src='https://gfx.tarot.com/images/daily-pages/daily-icons/hexagram.svg'
                      class='hexagram-unknown'
                      alt='Unknown Hexagram'
                    />
                </div>
                {this.renderDailyLinks()}
                <h1>Hexagram of<br />the Day</h1>
                {this.renderSubLinks()}
                <br />
                <h2>Your FREE I Ching Hexagram Awaits!</h2>
                <br />
                <p>
                    Looking for your Hexagram of the Day? Create your profile to receive a Hexagram that's
                    personalized to YOU every day!
                </p>
                <p>
                    <a href='#login' class='button'>GET MY DAILY HEXAGRAM</a>
                </p>
            </daily-hexagram-non-mobile>
        );
    }

    renderForEveryone = () => {
        if (this.props.hexagram && this.props.hexagram.everyone) {
            return (
                <daily-hexagram-non-mobile>
                    {this.renderHexagram(this.props.hexagram.everyone)}
                </daily-hexagram-non-mobile>
            );
        }

        return (<daily-hexagram-non-mobile />);
    }

    renderHexagram = (hexagram) => {
        if (hexagram) {
            return (
                <div>
                    <div class='daily-hexagram'>
                        <a href={`/i-ching/hexagrams/${hexagram.title.toLowerCase().replace(/\s+/g, '-')}`}>
                            <img
                              src={`https://gfx.tarot.com/images/iching/iching-general/${hexagram.id}.jpg`}
                              alt={hexagram.title}
                            />
                        </a>
                        <small>
                            <a href={`/i-ching/hexagrams/${hexagram.title.toLowerCase().replace(/\s+/g, '-')}`}>
                                #{hexagram.id}: {hexagram.title}
                            </a>
                        </small>
                    </div>
                    <DatePicker class='icon-24x23-calendar js-datepicker' url='/daily-hexagram/:date' />
                    {this.renderDailyLinks()}
                    <h1>Hexagram of<br />the Day</h1>
                    {this.renderSubLinks()}
                    <br />
                    <p><b>{moment(hexagram.date).format('M.D.YY')}:</b> <Raw content={hexagram.main_text} /></p>
                    <p><PromoMessage placement='text-hexagram' /></p>
                </div>
            );
        }

        return null;
    }

    renderDailyLinks = () => {
        const yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD');
        const today = moment().format('YYYY-MM-DD');
        const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');

        return (
            <div class='daily-links'>
                <a
                  href={`/daily-hexagram/${yesterday}#${this.props.route}`}
                  class={this.props.date == yesterday ? 'selected' : ''}
                >
                    Yesterday
                </a>
                <a
                  href={`/daily-hexagram/${today}#${this.props.route}`}
                  class={this.props.date == today ? 'selected' : ''}
                >
                    Today
                </a>
                <a
                  href={`/daily-hexagram/${tomorrow}#${this.props.route}`}
                  class={this.props.date == tomorrow ? 'selected' : ''}
                >
                    Tomorrow
                </a>
            </div>
        );
    }

    renderSubLinks = () => {
        return (
            <div class='daily-links'>
                <a href={this.props.route == 'everyone' ? '#you' : '#everyone'}>
                    {this.props.route == 'everyone' ? 'For You' : 'For Everyone'}
                </a>
                <a
                  href='http://t4dev60.tarot.com/readings-reports/i-ching/free'
                  onClick={() => this.props.trackPromo(['HOD', 'I-Ching'])}
                >
                    Get Your Daily I Ching Reading
                </a>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    hexagram: state.hexagram,
    logged_in: state.user && state.user.logged_in,
    route: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/daily/hexagram/non-mobile.js